export default __webpack_public_path__ + "static/media/dental-mark.60df497c.png";